exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.diseases-and-symptoms-checkbox[data-v-320a1c26] {\n  padding: 0;\n  margin: 0 0 -12px;\n}\n", ""]);

// exports
